import { render, staticRenderFns } from "./Submenu.vue?vue&type=template&id=5ce6c47e"
import script from "./Submenu.vue?vue&type=script&lang=js"
export * from "./Submenu.vue?vue&type=script&lang=js"
import style0 from "./Submenu.vue?vue&type=style&index=0&id=5ce6c47e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports